import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import "./home.css";
import Latastupdate from "../../components/latestUpdate/Latastupdate";
import Projects from "../../components/projects/Projects";
import Testimonial from "../../components/testimonial/Testimonial";
import HowItWorks from "../../components/howitworks/HowItWorks";
import DataAndResearchData from "../../components/data_and_research_reports/DataAndResearchData";

const Home = () => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const detectLanguage = () => {
      const el = document.querySelector(".nav-link");
      if (!el) return;

      const text = el.innerText;
      if (/[\u0D80-\u0DFF]/.test(text)) {
        setLang("si"); // Sinhala
      } else if (/[\u0B80-\u0BFF]/.test(text)) {
        setLang("ta"); // Tamil
      } else {
        setLang("en"); // Default
      }
    };

    const observer = new MutationObserver(detectLanguage);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    detectLanguage(); // Initial check

    return () => observer.disconnect();
  }, []);

  const headingStyle = {
    fontSize:
      lang === "si" ? "70px" : lang === "ta" ? "50px" : "80px",
    lineHeight: "1.1",
  };

  return (
    <div>
      <div className="header home ">
        <div className="container-7 w-container">
          <h5 className="heading-13" style={headingStyle}>
            <br />
            ALONE, SO LITTLE.
            <br />
            TOGETHER, SO MUCH…
          </h5>
        </div>
      </div>

      <div id="projects" className="section _1">
        <div className="w-container">
          <h2 className="home---heading-2">
            Gammadda-(The heart of the village); An initiative for the people by the people
          </h2>
          <p className="main_p">
            Rural Sri Lanka is an enigma. Over 35,000 villages, cross-divided into a myriad administrative regions ranging
            from 09 Provinces to 14,000+ GS Divisions. Each village, each locality, has its own endemic challenges.
            Understanding these issues is a profound undertaking that requires an investment in time, and hard miles. The
            uniqueness of Gammadda is, it listens to the people first. This is our core strength. We walk for thousands of
            miles each year, spending time with the people. Listening to their problems but equally importantly, to their
            solutions. It is learnings gleaned out of these experiences that we use to as the foundation of our rural
            development projects.
          </p>
          <div className="divider grey"></div>
        </div>
      </div>

      <Latastupdate />
      <Projects />

      <div id="projects" className="section">
        <div className="container" style={{ maxWidth: "940px" }}>
          <h2 className="gm---heading-2">
            <strong>Philosophy in Action - See what we do</strong>
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/qlC9jK-oJiE?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Gammadda Bridging Hearts, Transforming Lives in Sri Lanka"
                ></iframe>
              </div>
            </div>
            <div className="w-200" style={{ margin: "10px" }}></div>
            <div className="col-md-6 col-12 mb-3">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/YaS0Zub2IeA?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="සරණක් අවැසි ජනතාව වෙනුවෙන් ගම්මැද්ද...."
                ></iframe>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/i718Fz74WP0?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="அனைத்து இலங்கையர்களினதும் நம்பிக்கையாய் கம்மெத்த."
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <Testimonial />
    <HowItWorks />
    <DataAndResearchData/>
    </div>
  );
};

export default Home;
